import React from 'react';
import './Button.css';
import { useNavigate } from 'react-router-dom';

function ContactButton() {
  const navigate = useNavigate();

  return (
    <button className="btn-filled banner-contact-btn" onClick={() => navigate('/contact')}>
  CONTACTEZ-NOUS →
</button>
  );
}

export default ContactButton;
